export default __webpack_public_path__ + "media/images/onglet-centre-6b1aeea6b3a2c530f4ae8e13924fb12e.png";